import { TableCell } from "@mui/material"
import type { FC } from "react"

import { formatInventoryLocation } from "../../utils"

import { INVENTORY_PALLET_COLUMN_COUNT } from "./InventoryPalletTableHeaderCells"

import type { InventoryPalletGroup } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

interface InventoryPalletTableRowCellsProps {
  pallet: InventoryPalletGroup
  isFirstLot: boolean
  uomName: string
}

export const InventoryPalletTableRowCells: FC<InventoryPalletTableRowCellsProps> = ({ pallet, isFirstLot, uomName }) =>
  isFirstLot ? (
    <>
      <TableCell>{pallet.referenceNbr}</TableCell>
      <TableCell>{formatInventoryLocation(pallet.location)}</TableCell>
      <TableCell className='whitespace-nowrap'>{`${formatNumber(pallet.totalQoh)} ${uomName}`}</TableCell>
    </>
  ) : (
    <TableCell colSpan={INVENTORY_PALLET_COLUMN_COUNT} />
  )
